"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateCredentialResponseMapper = void 0;
var ValidateCredentialResponseMapper = /** @class */ (function () {
    function ValidateCredentialResponseMapper(data) {
        this.localData = data;
    }
    ValidateCredentialResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return ValidateCredentialResponseMapper;
}());
exports.ValidateCredentialResponseMapper = ValidateCredentialResponseMapper;
//# sourceMappingURL=ValidateCredentialResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/ValidateCredentialResponseMapper.js
// module id = 1969
// module chunks = 8